import { QueryResultCallback } from "../../models/Callback/Callback";
import { DealerGroup } from "../../models/Organization/DealerGroup";
import { TDealerGroupAttr, TFullOrganizationAttr, TOrganizationAttr, TOrgMemberAttr } from "../../models/Organization/Types";

import { DGroupStoreActions } from "../../redux/services/dealergroups/actions";
import { APIManager } from "../APIManager";
import { DGroupNetworkHelper } from "./NetworkHelper";

export class DealerGroupManager {
    networkHelper = DGroupNetworkHelper;
    static newOrgObj(data: TDealerGroupAttr) {
        return new DealerGroup(data);
    }
    getUserOrg(orgId: string) {
        return DGroupStoreActions.getOrganizations().find((t) => t.id === orgId);
    }
    static getActiveOrg() {
        return DGroupStoreActions.getActiveOrg();
    }
    saveUserOrganizations(orgs: TOrganizationAttr[]) {
        DGroupStoreActions.saveOrganizations(orgs.map((t) => DealerGroupManager.newOrgObj(t)));
    }
    getCurrentActiveOrg() {
        return DGroupStoreActions.getActiveOrg();
    }
    getPersistedActiveOrg() {
        const savedOrgId = DGroupStoreActions.getSavedOrgId();
        if (savedOrgId) {
            return DGroupStoreActions.getOrganizations().find((t) => t.id === savedOrgId);
        }
        return null;
    }
    getUserOrgs() {
        return DGroupStoreActions.getOrganizations();
    }
}
